import React from "react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$lang/maintenance")({
  component: React.lazy(() =>
    import("@/pages/errorPages/maintenance").then((mod) => ({
      default: mod.Maintenance,
    })),
  ),
});
